import * as ng from 'angular';

import { PanelHeaderData } from '@/atomic-components';
import { UiRights } from '@/configuration/rights';
import { AuthContextService, NetworkOverviewModel, UserSettingsManagerService } from '@/services';

export class TemplateNetworkOverviewController {

    public static $inject: string[] = ['$translate', 'userSettingsManager'];

    public userHasRightNetworkList = AuthContextService.isGranted(UiRights.RES_NETWORK_LIST); // used in template!
    public pageHeaderData: PanelHeaderData;
    public overviewServiceData: any;
    public expertView: boolean;
    public overviewModel: NetworkOverviewModel;
    public disableFilter: any = {
        fancyFilter: false,
        searchFilter: false
    };
    public simpleFilter: any;
    public extendedFilters: any;
    public overviewUiSettings: any;

    constructor(
        private $translate: ng.translate.ITranslateService,
        private userSettingsManager: UserSettingsManagerService
    ) {}

    public $onInit() {
        this.expertView = true;

        this.pageHeaderData = {
            backwardLink: 'network.dashboard',
            backwardText: this.$translate.instant('9a606991-45b5-4ec6-a927-ccfbaf9b24ae'),
            panelHeaderRoute: '',
            panelHeaderRouteParams: null,
            panelIcon: 'network-wired',
            panelTitle: this.$translate.instant('TR_230420-de5df2_TR')
        };

        this.overviewServiceData = {
            extendedFilters: this.extendedFilters,
            fancyFilterExpand: this.expertView,
            overviewUiSettings: this.overviewUiSettings,
            simpleFilter: this.simpleFilter
        };

        // Surpress backlink to dashboard on expert view because it auto-redirects to overview.
        this.userSettingsManager.getUiSettings().then(
            (result) => {
                if (result?.overviewSettings?.VirtualMachineOverviewCtrl?.expertView) {
                    this.pageHeaderData.backwardText = '';
                    this.pageHeaderData.backwardLink = '';
                    this.pageHeaderData.panelHeaderRouteParams = null;
                }
            }
        );
    }

    public expandWrapper = (toggle) => {
        this.expertView = toggle.expand;
    };
}

export class TemplateNetworkOverviewComponent implements ng.IComponentOptions {
    public bindings = {
        extendedFilters: '<',
        overviewModel: '<',
        overviewUiSettings: '<',
        simpleFilter: '<'
    };
    public template = require('./network-overview-template.html');
    public controller = TemplateNetworkOverviewController;
    public controllerAs = 'TemplateNetworkOverviewCtrl';
}
